import { render, staticRenderFns } from "./cross-link-banner.vue?vue&type=template&id=61bc3980&scoped=true&"
import script from "./cross-link-banner.vue?vue&type=script&lang=js&"
export * from "./cross-link-banner.vue?vue&type=script&lang=js&"
import style0 from "./cross-link-banner.vue?vue&type=style&index=0&id=61bc3980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bc3980",
  null
  
)

export default component.exports